(() => {
  const storageKey = 'xvxii:saved-products:v1';
  const dialog = document.querySelector('[data-xvxii-wishlist-dialog]');
  const itemsContainer = dialog?.querySelector('[data-xvxii-wishlist-items]');
  const emptyState = dialog?.querySelector('[data-xvxii-wishlist-empty]');

  const readItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  };

  const writeItems = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 100)));
    } catch (error) {
      return;
    }
    sync(items);
  };

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const render = (items) => {
    if (!itemsContainer || !emptyState) return;
    itemsContainer.replaceChildren();
    emptyState.classList.toggle('is-visible', items.length === 0);

    items.forEach((item) => {
      const row = createElement('article', 'xvxii-wishlist__item');
      const imageLink = createElement('a', 'xvxii-wishlist__item-image');
      imageLink.href = item.url;
      imageLink.setAttribute('aria-label', item.title);
      if (item.image) {
        const image = createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        imageLink.append(image);
      }

      const copy = createElement('div', 'xvxii-wishlist__item-copy');
      const title = createElement('a', 'xvxii-wishlist__item-title', item.title);
      title.href = item.url;
      const price = createElement('p', 'xvxii-wishlist__item-price', item.price);
      copy.append(title, price);

      const remove = createElement('button', 'xvxii-wishlist__remove', 'Remove');
      remove.type = 'button';
      remove.dataset.xvxiiWishlistRemove = item.id;
      remove.setAttribute('aria-label', `Remove ${item.title}`);
      row.append(imageLink, copy, remove);
      itemsContainer.append(row);
    });
  };

  const sync = (items = readItems()) => {
    const ids = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-xvxii-wishlist-toggle]').forEach((button) => {
      const saved = ids.has(String(button.dataset.productId));
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.productTitle}`);
      const label = button.querySelector('[data-xvxii-wishlist-button-label]');
      if (label) label.textContent = `${saved ? 'Remove' : 'Save'} ${button.dataset.productTitle}`;
    });
    document.querySelectorAll('[data-xvxii-wishlist-count]').forEach((count) => {
      count.hidden = items.length === 0;
      const value = count.querySelector('span');
      if (value) value.textContent = items.length > 99 ? '99+' : String(items.length);
    });
    render(items);
  };

  const toggle = (button) => {
    const id = String(button.dataset.productId || '');
    if (!id) return;
    const items = readItems();
    const existingIndex = items.findIndex((item) => String(item.id) === id);
    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift({
        id,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }
    writeItems(items);
  };

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-xvxii-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton);
      return;
    }

    if (event.target.closest('[data-xvxii-wishlist-open]')) {
      event.preventDefault();
      sync();
      if (dialog?.showModal) dialog.showModal();
      else dialog?.setAttribute('open', '');
      return;
    }

    if (event.target.closest('[data-xvxii-wishlist-close]')) {
      dialog?.close();
      return;
    }

    const removeButton = event.target.closest('[data-xvxii-wishlist-remove]');
    if (removeButton) {
      writeItems(readItems().filter((item) => String(item.id) !== removeButton.dataset.xvxiiWishlistRemove));
    }
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) sync();
  });
  document.addEventListener('shopify:section:load', () => sync());
  sync();
})();
